<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.35 32">ß
		<path fill="#ffd85f" d="M9.7,22.3A8.53,8.53,0,0,1,7,16,8.83,8.83,0,0,1,9.6,9.7a3.54,3.54,0,0,0-5-5A16.29,16.29,0,0,0,0,16,16,16,0,0,0,4.7,27.3a3.5,3.5,0,0,0,5,0A3.69,3.69,0,0,0,9.7,22.3Z"/>
		<path fill="#3bb4e7" d="M9.7,9.7A8.53,8.53,0,0,1,16,7a8.83,8.83,0,0,1,6.3,2.6,3.54,3.54,0,0,0,5-5A16.29,16.29,0,0,0,16,0,16,16,0,0,0,4.7,4.7a3.5,3.5,0,0,0,0,5A3.69,3.69,0,0,0,9.7,9.7Z"/>
		<path fill="#ed5c68" d="M22.3,22.3A8.53,8.53,0,0,1,16,25a8.83,8.83,0,0,1-6.3-2.6,3.54,3.54,0,0,0-5,5A16.29,16.29,0,0,0,16,32a16,16,0,0,0,11.3-4.7,3.5,3.5,0,0,0,0-5A3.69,3.69,0,0,0,22.3,22.3Z"/>
		<circle fill="#308bc5" cx="7.2" cy="7.2" r="3.5"/>
		<circle fill="#d5465f" cx="7.2" cy="24.8" r="3.5"/></svg>
</template>

<script>
export default { name: 'contentful' }
</script>